<div class="relative grid drop-shadow-md" [class]="direction() === 'LEFT' ? '-scale-x-100' : undefined">
  <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 80 80" fill="none">
    <path
      d="M40 2C60.9892 2 78 19.0108 78 40C78 60.9892 60.9892 78 40 78C19.0108 78 2 60.9892 2 40C2 19.0108 19.0108 2 40 2Z"
      fill="white"
      stroke="#CBD5E1"
      stroke-width="4"
    />
    <path
      d="M38.6339 21.3099C36.8757 19.5516 34.0223 19.5517 32.264 21.3099C30.5058 23.0681 30.5057 25.9215 32.264 27.6798L44.5835 40L32.2715 52.3192C30.5137 54.0774 30.5138 56.9306 32.2719 58.6887C34.0301 60.4468 36.8832 60.4467 38.6414 58.6887L54.1511 43.1633C55.8924 41.4037 55.8868 38.5628 54.1343 36.8102L38.6339 21.3099Z"
      fill="#334155"
    />
  </svg>
</div>
